export enum FeedbackType {
    ThumbsUp = "ThumbsUp",
    ThumbsDown = "ThumbsDown"
}

export interface IFeedbackData {
    id?: number;
    datadogTraceId: string;
    businessUnitId: string;
    promptText: string;
    responseText: string;
    feedback: FeedbackType;
}
